export default [
    {
        path: '/propostas-venda-direta', component: () => import('./components/Page'), name: 'propostas-venda-direta.page', children: [
            {path: '', component: () => import('./components/List'), name: 'propostas-venda-direta'},
            {path: ':id', component: () => import('./components/Show'), name: 'propostas-venda-direta.show'},
        ]
    }
]
